import React, { useContext, useEffect } from "react";
import { RootStoreContext } from "../../../app/stores/rootStore";
import LoadComponent from "../../../app/layout/LoadComponent";
import { Button, Grid } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { Link } from "react-router-dom";
import BannerList from "./BannerList";

const BannerDashboard: React.FC = () => {
  const rootStore = useContext(RootStoreContext);
  const { loadBanners, loadingInitial } = rootStore.bannerStore;

  useEffect(() => {
    loadBanners();
  }, [loadBanners]);

  if (loadingInitial)
    return <LoadComponent content="Carregando banners..." />;

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={14}>
          <h1>Banners</h1>
        </Grid.Column>
        <Grid.Column width={2}>
          <Button
            as={Link}
            to="/admin/novobanner"
            active
            positive
            content="Novo"
            floated="right"
            style={{ marginTop: "12px" }}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column width={16}>
          <BannerList />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default observer(BannerDashboard);
